
<script>
import config from "./config.js";
export default {
  name: 'SubMenuItem',
  props: {
    data: {
      type: Object,
      required: true
    },
    first: {
      type: Boolean,
      default: false
    },
    props: {
      type: Object,
      default: () => {
        return {};
      }
    },
    collapse: {
      type: Boolean
    }
  },
  data() {
    return {
      singleChild: {},
      config: config
    }
  },

  computed: {
    hasChildren() {
      const data = this.data;
      return data.children && data.children.length > 0;
    },
    routeName() {
      return this.props.label || this.config.propsDefault.label;
    },
    path() {
      return this.props.path || this.config.propsDefault.path;
    },
    icon() {
      return this.props.icon || this.config.propsDefault.icon;
    },
    children() {
      return this.props.children || this.config.propsDefault.children;
    }
  },
  methods: {
    open (item) {
        if (this.screen <= 1) this.$store.commit("SET_COLLAPSE");
        this.$router.$avueRouter.group = item.group;
        this.$router.$avueRouter.meta = item.meta;
        this.$router.push({
          path: this.$router.$avueRouter.getPath({
            name: item[this.labelKey],
            src: item[this.path]
          }, item.meta),
          query: item.query
        });
      }
  },

  render() {
    const { data, path, icon, routeName, children, hasChildren, collapse } = this;
    // const single = data.children[0];
    if (!hasChildren) {
      return (
        <div class="menu-wrapper">
          <router-link to={{ name: data[routeName]}}>
            <el-menu-item index={data[path]}>
              <i class={data[icon]}></i>
              <span slot="title" alt={data[path]}>{data['name']}</span>
            </el-menu-item>
          </router-link>
        </div>
      )
    } else {
      return (
        <div class="menu-wrapper">
          <el-submenu index={data[path]}>
            <template slot="title">
              <i class={data[icon]}></i>
              <span slot="title" class={ collapse ? 'el-menu--display': 'none' }>{data['name']}</span>
            </template>
            {
              data[children].map(child => (<sub-menu-item data={child} key={child[path]}></sub-menu-item>))
            }
          </el-submenu>
        </div>
      )
    }
  }
}
</script>
<style lang="scss">
  // .a {color: red }
</style>